import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icn-low",
  "use": "icon-icn-low-usage",
  "viewBox": "0 0 10 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 14\" id=\"icon-icn-low\"><path d=\"M4.169 13.615L.372 9.614A1.397 1.397 0 01.36 7.728a1.196 1.196 0 011.767-.011L3.75 9.425V1.333C3.75.597 4.31 0 5 0s1.25.597 1.25 1.333v8.194l1.622-1.71a1.196 1.196 0 011.767.011c.485.524.48 1.368-.01 1.886l-3.703 3.901a1.195 1.195 0 01-1.757 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol